import React from 'react'
import ClientPortal from '../components/ClientPortal'

export default function ClientPortalPage() {
    return (
        <>
            <ClientPortal />
        </>
    )
}
